import { useState } from 'react';

import type { ImsApi } from '@/api/ImsApi.ts';

import { LandingPage } from './LandingPage';

export const INVITE_KEY = 'beacon_invited';

// eslint-disable-next-line react-refresh/only-export-components
export const markAsInvited = (): boolean => {
	try {
		localStorage.setItem(INVITE_KEY, 'true');
		return true;
	} catch {
		return false;
	}
};

const checkInvited = (): boolean => {
	const params = new URLSearchParams(window.location.search);
	if (params.get('invite') === 'bridgeway') {
		if (markAsInvited()) {
			try {
				params.delete('invite');
				const newUrl =
					window.location.pathname +
					(params.toString() ? `?${params.toString()}` : '') +
					window.location.hash;
				window.history.replaceState({}, '', newUrl);
			} catch {
				/* replaceState unavailable — flag is set, URL stays */
			}
		}
		return true;
	}
	try {
		return localStorage.getItem(INVITE_KEY) === 'true';
	} catch {
		return false;
	}
};

export const Login = ({
	imsApi,
	showLogout,
	onLogout,
}: {
	imsApi: ImsApi;
	showLogout?: boolean;
	onLogout?: () => void;
}) => {
	const [isInvited] = useState(checkInvited);

	return (
		<LandingPage
			onAuth={() => imsApi.redirectToImsAuth()}
			showLogout={showLogout}
			onLogout={onLogout}
			isInvited={isInvited}
		/>
	);
};
